import { Component, OnInit } from '@angular/core';
import { DataTaskService } from '../../../core/services/data-task.service';
import { ModalService } from '../../../core/services/modal.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-sub-operation-lang',
  templateUrl: './sub-operation-lang.component.html',
  styleUrls: ['./sub-operation-lang.component.css']
})
export class SubOperationLangComponent implements OnInit {
    subOperationKeyno;

    public inputListLanguages: LanguageItem[] = [];

    public saving = false;

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService) {
        this.subOperationKeyno = this.stateService.getStateParams()['suboperation_keyno'];
    }

    private async loadLanguages() {
        if (!!this.subOperationKeyno) {
            this.inputListLanguages = await this.datatask.Post(2467, { suboperation_keyno: this.subOperationKeyno });
        }
    }

    public async saveChanges() {
        if (!!this.inputListLanguages) {
            try {
                this.saving = true;

                const response = (await this.datatask.Post(2468, { records: this.inputListLanguages }))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.stateService.back();
                }
            } finally {
                this.saving = false;
            }
        }
    }

    private async init() {
        this.loadLanguages();
    }

    ngOnInit() {
        this.init();
    }
}

interface LanguageItem {
    suboperation_keyno: string;
    suboperation_name: string;
    language_id: string;
    language_name: string;
    orderby: number;
}
